import { render, staticRenderFns } from "./statsbar.vue?vue&type=template&id=436a8ff6&scoped=true"
import script from "./statsbar.vue?vue&type=script&lang=js"
export * from "./statsbar.vue?vue&type=script&lang=js"
import style0 from "./statsbar.vue?vue&type=style&index=0&id=436a8ff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a8ff6",
  null
  
)

export default component.exports